module.exports = __webpack_public_path__ + "img/clementeseguel.a443eea1.jpg";